function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21",
  height: "21",
  viewBox: "0 0 21 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10.149 20.91h-.655a3.796 3.796 0 01-3.797-3.797v-1.898a.949.949 0 00-.949-.95H3.4a3.417 3.417 0 01-3.398-3.417 10.64 10.64 0 019.7-10.82A10.441 10.441 0 0120.885 11.21a10.622 10.622 0 01-10.736 9.7zm.294-18.983h-.598a8.732 8.732 0 00-7.944 8.836 1.538 1.538 0 001.5 1.604h1.347a2.847 2.847 0 012.848 2.847v1.899a1.899 1.899 0 001.898 1.898h.655a8.732 8.732 0 008.836-7.935 8.542 8.542 0 00-8.542-9.15z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.242 15.689a1.424 1.424 0 11-2.847 0 1.424 1.424 0 012.847 0zM17.087 9.994a1.424 1.424 0 11-2.847 0 1.424 1.424 0 012.847 0zM13.29 5.25a1.424 1.424 0 11-2.847 0 1.424 1.424 0 012.847 0zM7.595 7.148a1.424 1.424 0 11-2.847 0 1.424 1.424 0 012.847 0z",
  fill: "#fff"
})));